var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-cy":"dashboard-page"}},[_c('Content',{attrs:{"dashboard-data":_vm.dashboardData},on:{"withdrawalCreated":_vm.getDashboardData}}),_c('PasswordModal'),_c('Modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }